import { Outlet, useNavigate } from "react-router-dom";
import { IMenuNavItem } from "../../common/inerfaces/component-interfaces";
import GuestHomeHeader from "../../guest/components/home-header/home-header";
import "./guest-layout.scss";

const GuestLayout: React.FC = () => {
  const navigate = useNavigate();
  const menuItemSelectionChangeHandler = (menuItem: IMenuNavItem) => {
    navigate(menuItem.path);
  };
  return (
    <main className="guest-layout-main">
      {/* <GuestHomeHeader/> */}
      {/* <div> */}
        <Outlet />
      {/* </div> */}
    </main>
  );
};

export default GuestLayout;
